const initialState: any = {
  user: {
    loadingState: true,
    loading: true,
    data: {},
  },
  books: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  userBooks: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  userBookLent: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  userBookBorrow: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  book: {
    data: {},
    loading: true,
    loadingState: true,
  },
  users: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  bookCategories: {
    data: [],
    loading: true,
    loadingState: true,
  },
  topBanner: {
    loading: true,
    loadingState: true,
    data: [],
  },
  bottomBanner: {
    loading: true,
    loadingState: true,
    data: [],
  },
  drivers: {
    items: [],
    loading: true,
    loadingState: true,
    totalItems: 0,
    totalPages: 0,
  },
  aboutUs: {
    data: {},
    loading: true,
    loadingState: true,
  },
  termsCondition: {
    data: {},
    loading: true,
    loadingState: true,
  },
  privacyPolicy: {
    data: {},
    loading: true,
    loadingState: true,
  },
  refundPolicy: {
    data: {},
    loading: true,
    loadingState: true,
  },
  aboutUsSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  termsConditionSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  privacyPolicySeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  refundPolicySeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  officeDetail: {
    data: {},
    loading: true,
    loadingState: true,
  },
  supportAgent: {
    data: {},
    loading: true,
    loadingState: true,
  },
  homeSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  loginSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  orders: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  generalSetting: {
    loading: true,
    loadingState: true,
    data: {},
  },
  notifications: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  registerSeo: {
    data: {},
    loading: true,
    loadingState: true,
  },
  lendOrder: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  borrowOrder: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  transactions: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  dashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },
  bookDashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },
  usersDashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },
  singleUserDashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },
  orderDashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },
  deliveryDashboard: {
    data: {},
    loading: true,
    loadingState: true,
  },
  singleUser: {
    data: {},
    loading: true,
    loadingState: true,
  },
  selectedGenre: '',
  transactionsList: {
    items: [],
    loading: true,
    loadingState: true,
    totalPages: 0,
    totalItems: 0,
  },
  totalUnreadNotification: 0,
  footer: {
    data: {},
    loading: true,
    loadingState: true,
  },
}

export default initialState
